import React from "react";
import { Link } from "react-router-dom";
import aboutImage from '../assets/images/solar/award.webp'
import CountUp from 'react-countup';

export default function About(){
    return(
        <section className="relative py-20 lg:py-28 bg-gradient-to-br from-slate-50 to-teal-50 dark:from-slate-900 dark:to-slate-800" id="about">
            {/* Background decorative elements */}
            <div className="absolute top-0 left-0 w-72 h-72 bg-teal-500/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/5 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
            
            <div className="container relative">
                <div className="grid lg:grid-cols-12 grid-cols-1 items-center gap-10 lg:gap-16">
                    {/* Image Section - Enhanced with modern design */}
                    <div className="lg:col-span-6">
                        <div className="relative">
                            {/* Main Image Container */}
                            <div className="relative z-10">
                                <div className="relative overflow-hidden rounded-2xl lg:rounded-3xl shadow-2xl shadow-teal-500/10">
                                    <img 
                                        src={aboutImage} 
                                        className="w-full h-auto transform hover:scale-105 transition-transform duration-700" 
                                        alt="RENERG LTD - Green Energy Solutions"
                                    />
                                    {/* Gradient Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-60"></div>
                                </div>
                            </div>



                           

                            {/* Pattern Background */}
                            <div className="absolute -z-10 -inset-6">
                                <div className="w-full h-full border-2 border-teal-500/20 rounded-3xl rotate-3"></div>
                            </div>
                        </div>
                    </div>

                    {/* Content Section - Enhanced with modern typography */}
                    <div className="lg:col-span-6">
                        <div className="lg:ms-8">
                            {/* Badge with icon */}
                            <div className="inline-flex items-center gap-3 px-4 py-2.5 bg-teal-500/10 border border-teal-500/20 rounded-full mb-6">
                                <div className="flex items-center justify-center w-6 h-6 bg-teal-500 rounded-full">
                                    <span className="text-white text-sm">★</span>
                                </div>
                                <span className="text-teal-600 dark:text-teal-400 text-sm font-semibold uppercase tracking-wider">Who We Are</span>
                            </div>

                            {/* Main Heading */}
                            <h3 className="font-bold text-3xl lg:text-4xl xl:text-5xl leading-tight mb-6 text-slate-800 dark:text-white">
                                Leading <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 to-emerald-600">Green Energy</span> Innovators in Rwanda
                            </h3>

                            {/* Description with improved readability */}
                            <div className="space-y-4 mb-8">
                                <p className="text-slate-600 dark:text-slate-300 text-lg leading-relaxed">
                                    <strong>RENERG (R) LTD</strong> is a registered private company in Rwanda, standing at the forefront of sustainable energy solutions with over <strong>15 years of expertise</strong> in the green business sector.
                                </p>
                                
                                <p className="text-slate-600 dark:text-slate-300 text-lg leading-relaxed">
                                    Our footprint extends across <strong>12+ African countries</strong>, where we've successfully delivered more than <strong>1.3 GW of solar projects</strong>, driving the continent's transition to clean energy.
                                </p>

                                <div className="bg-teal-500/5 border-l-4 border-teal-500 p-4 rounded-r-lg">
                                    <p className="text-slate-700 dark:text-slate-200 text-lg font-medium">
                                        🏆 Winner of the 2019 "Beat Air Pollution" Environmental Award for outstanding contribution to greenhouse gas reduction and clean energy access.
                                    </p>
                                </div>
                            </div>

                            {/* Services Highlights */}
                            {/* <div className="grid grid-cols-2 gap-4 mb-8">
                                <div className="flex items-center gap-3 p-3 bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700">
                                    <div className="w-8 h-8 bg-teal-500/10 rounded-lg flex items-center justify-center">
                                        <span className="text-teal-500 text-lg">☀️</span>
                                    </div>
                                    <span className="text-slate-700 dark:text-slate-300 font-medium text-sm">Solar Planning</span>
                                </div>
                                <div className="flex items-center gap-3 p-3 bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700">
                                    <div className="w-8 h-8 bg-teal-500/10 rounded-lg flex items-center justify-center">
                                        <span className="text-teal-500 text-lg">🏗️</span>
                                    </div>
                                    <span className="text-slate-700 dark:text-slate-300 font-medium text-sm">Installation</span>
                                </div>
                                <div className="flex items-center gap-3 p-3 bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700">
                                    <div className="w-8 h-8 bg-teal-500/10 rounded-lg flex items-center justify-center">
                                        <span className="text-teal-500 text-lg">🔧</span>
                                    </div>
                                    <span className="text-slate-700 dark:text-slate-300 font-medium text-sm">Maintenance</span>
                                </div>
                                <div className="flex items-center gap-3 p-3 bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700">
                                    <div className="w-8 h-8 bg-teal-500/10 rounded-lg flex items-center justify-center">
                                        <span className="text-teal-500 text-lg">💡</span>
                                    </div>
                                    <span className="text-slate-700 dark:text-slate-300 font-medium text-sm">Consulting</span>
                                </div>
                            </div> */}

                            {/* Enhanced CTA Button */}
                            {/* <div className="flex flex-col sm:flex-row gap-4">
                                <Link 
                                    to="/about" 
                                    className="group inline-flex items-center justify-center h-12 px-8 font-semibold rounded-xl bg-gradient-to-r from-teal-500 to-emerald-600 text-white shadow-lg shadow-teal-500/25 hover:shadow-xl hover:shadow-teal-500/40 hover:scale-105 transition-all duration-300"
                                >
                                    Discover Our Story
                                    <i className="mdi mdi-arrow-right align-middle ms-2 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
                                </Link>
                                
                                <Link 
                                    to="/projects" 
                                    className="group inline-flex items-center justify-center h-12 px-8 font-semibold rounded-xl border-2 border-teal-500 text-teal-500 dark:text-teal-400 hover:bg-teal-500 hover:text-white transition-all duration-300"
                                >
                                    View Projects
                                    <i className="mdi mdi-folder-multiple-image align-middle ms-2 text-xl group-hover:scale-110 transition-transform duration-300"></i>
                                </Link>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}